exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".webEnquiries{color:red}.table-light{background-color:#f5f5f5}.comment-cell{font-size:10px;padding-bottom:10px;background-color:#d0cfc0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/dashboard/webEnquiries/webEnquiries.styl
// module id = 1503
// module chunks = 0